(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-part', {
            parent: 'entity',
            url: '/public-site-part?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePart.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part/public-site-parts.html',
                    controller: 'PublicSitePartController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePart');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-part-detail', {
            parent: 'entity',
            url: '/public-site-part/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePart.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part/public-site-part-detail.html',
                    controller: 'PublicSitePartDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePart');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSitePart', function($stateParams, PublicSitePart) {
                    return PublicSitePart.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-part',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-part-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-dialog.html',
                    controller: 'PublicSitePartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePart', function(PublicSitePart) {
                            return PublicSitePart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-dialog.html',
                    controller: 'PublicSitePartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-part', null, { reload: 'public-site-part' });
                }, function() {
                    $state.go('public-site-part');
                });
            }]
        })
        .state('public-site-part.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-dialog.html',
                    controller: 'PublicSitePartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePart', function(PublicSitePart) {
                            return PublicSitePart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part', null, { reload: 'public-site-part' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-delete-dialog.html',
                    controller: 'PublicSitePartDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSitePart', function(PublicSitePart) {
                            return PublicSitePart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part', null, { reload: 'public-site-part' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
